import React from 'react';
import {Provider} from "react-redux";
import Dashboard from "./components/dashboard/Dashboard";
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './ducks/configureStore';
import LightRays from "./components/background/LightRays.jsx";
import {isMobile} from "./util/misc.js";

const {store, persistor} = configureStore();

export default function App() {
    return (
        <div>
            <div style={{
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: 0,
                left: 0,
            }}>
                <LightRays
                    raysOrigin="top-center"
                    raysColor="#b33da3"
                    raysSpeed={0.5}
                    lightSpread={2}
                    rayLength={isMobile() ? 1.8 : 1.2}
                    followMouse={false}
                    mouseInfluence={0.1}
                    noiseAmount={0.1}
                    distortion={0.05}
                    className="custom-rays"
                />
            </div>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <Dashboard />
                </PersistGate>
            </Provider>
        </div>
    );
};
